"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Label;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const variables_1 = __importDefault(require("../../styles/variables"));
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, core_1.makeStyles)({
    label: {
        color: variables_1.default.colors.text.default,
        fontSize: variables_1.default.fonts.size.small,
    },
    asterisk: { color: variables_1.default.colors.text.critical, marginLeft: '2px' },
});
function Label({ label, required, className }) {
    const classes = useStyles();
    let asterisk;
    if (required) {
        asterisk = (react_1.default.createElement("span", { className: classes.asterisk, "data-testid": "asterisk" }, "*"));
    }
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.label, className), "data-testid": "inputLabel" },
        label,
        asterisk));
}
